if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      const productSection = this.dataset.warrantySection && document.getElementById(`MainProduct-${this.dataset.warrantySection}`);
      if (productSection && productSection.dataset.warrantyBusy === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const warranty = productSection && productSection.querySelector('[data-extra-warranty]');
      const warrantyInput = warranty && warranty.querySelector('input');
      // The sticky button uses the selection and quantity from the main product form.
      if (warranty && this.hasAttribute('data-warranty-sticky')) {
        const quantityInput = productSection.querySelector('[name="quantity"]');
        formData.set('quantity', quantityInput ? quantityInput.value : '1');
      }
      let requestData = formData;
      if (warrantyInput && warrantyInput.checked) {
        const group = window.crypto.randomUUID();
        requestData = new FormData();
        for (const [key, value] of formData.entries()) {
          const property = key.match(/^properties\[(.*)\]$/);
          if (property) requestData.append(`items[0][properties][${property[1]}]`, value);
          else if (['id', 'quantity', 'selling_plan'].includes(key)) requestData.append(`items[0][${key}]`, value);
        }
        if (!formData.has('quantity')) requestData.append('items[0][quantity]', '1');
        requestData.append('items[0][properties][_extra_warranty_group]', group);
        requestData.append('items[0][properties][_extra_warranty_role]', 'product');
        requestData.append('items[1][id]', warranty.dataset.variantId);
        requestData.append('items[1][quantity]', formData.get('quantity') || '1');
        requestData.append('items[1][parent_id]', formData.get('id'));
        requestData.append('items[1][properties][_extra_warranty_group]', group);
        requestData.append('items[1][properties][_extra_warranty_role]', 'service');
      }
      if (warrantyInput) warrantyInput.disabled = true;
      if (warranty) productSection.dataset.warrantyBusy = 'true';
      const relatedButtons = warranty ? Array.from(productSection.querySelectorAll('product-form [type="submit"]')) : [];
      relatedButtons.forEach((button) => button.setAttribute('aria-disabled', 'true'));
      if (this.cart) {
        requestData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        requestData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = requestData;

      return fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            // A service stock error must not turn the main product into a sold-out button.
            if (requestData !== formData) {
              this.error = false;
              return;
            }

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          // Multi-item additions return an items array; notifications expect the main item's key.
          if (response.items) Object.assign(response, response.items[0]);
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage('Nu am putut confirma adăugarea în coș. Verifică coșul înainte de a încerca din nou.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          relatedButtons.forEach((button) => {
            if (button !== this.submitButton) button.removeAttribute('aria-disabled');
          });
          if (warrantyInput) warrantyInput.disabled = false;
          if (warranty) delete productSection.dataset.warrantyBusy;
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.update.bind(this));
    this.update();
    document.querySelector('footer').classList.add('sticky-cart-modal_bottom_padding');
  }
  update(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
	const addButton = button.querySelector('[name="add"]');
    const rangeToShowModal = this.getTop(addButton) + button.clientHeight;
    if(window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')){
      this.classList.add('show-modal');
      this.setAttribute('aria-hidden', 'false');
      document.querySelector('body').classList.add('modal__sticky-cart');
    }
    if(window.scrollY < rangeToShowModal && this.classList.contains('show-modal')){
      this.classList.remove('show-modal');
      this.setAttribute('aria-hidden', 'true');
      document.querySelector('body').classList.remove('modal__sticky-cart');
    }
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);

